/* eslint-disable react/destructuring-assignment */
import React, { lazy } from 'react'
import ReactDOM from 'react-dom'

import { AppInitProps } from '../../app/view/AppInit'

import { withSuspense } from '../../app/shared/hoc/withSuspense'
import { TariffSkeleton } from '../../app/view/Tariff/Tariff.skeleton'
import { DocumentCreateSkeleton } from '../../app/shared/componets/Document/DocumentCreate/DocumentCreate/DocumentCreate.skeleton'
import { AuthSkeleton } from '../../app/view/Auth/Auth.skeleton'
import withWrapperPage from '../../app/shared/hoc/withWrapperPage'
import pjson from '../../../package.json'

const Document = lazy(() => import('../elements/Document'))
const Tariff = lazy(() => import('../elements/Tariff'))
const Auth = lazy(() => import('../elements/Auth'))

interface DOMWidgetProps extends Omit<AppInitProps, 'mode'>{
  selector: string
}

const withRenderDOM = (Component: React.FC<Omit<AppInitProps, 'mode'>>) => {
  return ({
    selector,
    ...props
  }: DOMWidgetProps) => {
    ReactDOM.render(
      <Component {...props} />,
      document.querySelector(selector),
    )
  }
}

const DocumentLazy = withSuspense(Document, withWrapperPage(DocumentCreateSkeleton))
const TariffLazy = withSuspense(Tariff, TariffSkeleton)
const AuthLazy = withSuspense(Auth, AuthSkeleton);

// From cdn
(window as any).DOMWidget = {
  Document: withRenderDOM(DocumentLazy),
  Tariff: withRenderDOM(TariffLazy),
  Auth: withRenderDOM(AuthLazy),
  version: pjson.version,
}
